import React from "react";
import Industries from "../../Data/Industries";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import jwt_decode from "jwt-decode";
import "./MatchingIndustry.css";
import InputErrorMessage from "../../Components/InputErrorMessage/InputErrorMessage";
import GooLoader from "../../Components/GooLoader/GooLoader";
import MultiSelectCheckbox from "../../Components/MultiselectCheckbox/MultiSelectCheckbox";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet-async";

class MatchingIndustry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showButton: false,
      checkedIndustries: [],
      error: "",
      isLoading: true,
    };

    this.handleMatchingCriteria1 = this.handleMatchingCriteria1.bind(this);
    this.handleCheckboxOnChange = this.handleCheckboxOnChange.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (
        this.props.location.state === undefined ||
        !this.props.location.state.userData ||
        !this.props.location.state.userData.matching_criteria
      ) {
        if (!decoded.active) {
          this.props.history.push("/");
        } else {
          this.props.history.push("/dashboard");
        }
      } else {
        let userData = this.props.location.state.userData;
        if (!decoded.active) {
          this.props.history.push("/payment", { userData: userData });
        } else {
          const { matching_criteria } = userData;
          if (!matching_criteria) {
            this.props.history.push("/welcome", { userData: userData });
          } else {
            if (
              this.props.matching_criteria_1 !== "" &&
              this.props.matching_criteria_1.length > 0
            ) {
              this.setState({
                checkedIndustries: this.props.matching_criteria_1,
                isLoading: false,
                showButton: true,
              });
            } else {
              this.setState({
                checkedIndustries: [],
                isLoading: false,
              });
            }
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.checkedIndustries !== prevState.checkedIndustries) {
      if (this.state.checkedIndustries.length > 0) {
        this.setState({
          showButton: true,
        });
      } else {
        this.setState({
          showButton: false,
        });
      }
    }
  }

  handleCheckboxOnChange(e) {
    const checkedValues = [...this.state.checkedIndustries];
    const value = e.target.value;
    if (e.target.checked) {
      const index = checkedValues.indexOf(value);
      if (index > -1) {
        checkedValues.splice(index, 1);
      }
    } else {
      checkedValues.push(e.target.value);
    }
    this.setState(
      {
        checkedIndustries: checkedValues,
      },
      () => {
        this.props.setMatchingCriteria1(this.state.checkedIndustries);
      }
    );
  }

  handleMatchingCriteria1() {
    let value = this.state.checkedIndustries;
    if (value.length <= 0) {
      this.setState({
        error: "Please select a value",
      });
    } else {
      let userData = this.props.location.state.userData;
      this.props.history.push("/matching-criteria-2", {
        userData: {
          ...userData,
          matching_criteria: {
            industry: value,
          },
        },
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          containerClassName="container-matching-industry-1"
          hasCounter={true}
          step="1"
          hasQuote={false}
          headerText="Which industry most closely matches yours?"
          primaryButtonText="Next step"
          hasSkip={false}
          handlePrimaryBtnOnClick={this.handleMatchingCriteria1}
          activatePrimaryWithEnter={true}
          showButton={this.state.showButton}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          {this.state.error !== "" ? (
            <div className="form-container-body-row">
              <InputErrorMessage errorText={this.state.error} />
            </div>
          ) : null}
          <div className="form-container-body-row">
            <MultiSelectCheckbox
              data={Industries}
              name="industry_choice"
              checkedValues={this.state.checkedIndustries}
              placeholder="Choose industry..."
              zIndexValue={5}
              label="Industry"
              inputName="industry"
              handleCheckboxOnChange={this.handleCheckboxOnChange}
              keyword="industries"
            />
          </div>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default withRouter(MatchingIndustry);
